import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async () => {
  const res = await httpRequest.get("/api/notification");
  return res;
};
